

export const getToken = () => localStorage.getItem("TOKEN");
export const getRToken = () => localStorage.getItem("RTOKEN");
export const getProfile = () => localStorage.getItem("PROFILE");

export const setToken = (value: string) => localStorage.setItem("TOKEN", value);


export const getUrl = async () => {
  const response = await fetch("/resources/config.json");
  const results = await response.json();
  return results;
}


export const logout = (): void => {
  localStorage.removeItem("TOKEN");
  localStorage.removeItem("RTOKEN");
  localStorage.removeItem("PROFILE");
  window.location.reload()
};
